import { RequestUtils } from '@edapp/request';
import type { GetUserAuthToken } from './types';

export const getUserAuthToken: GetUserAuthToken = (hippoUrl, userToken) =>
  RequestUtils.httpFetch(
    'GET',
    `${hippoUrl}/api/authentication/notification-auth-token`,
    userToken
  );
